<template>
	<transition name="slide-fade" mode="in-out">
		<div v-show="showCookieNotice" class="cookie-container">
			<div class="cookie-header">
				<div class="cookie-title">
					<span>
						<ion-icon name="ios-megaphone"></ion-icon>&nbsp;Notice
					</span>
				</div>
				<div class="close" @click="close">
					<ion-icon name="ios-close"></ion-icon>
				</div>
			</div>
			<div class="cookie-body">
				<p>This site uses cookies. By using this site you agree to receiving cookies.</p>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			showCookieNotice: true
		};
	},
	beforeMount() {
		if (window.localStorage) {
			const stackCookies = JSON.parse(localStorage.getItem("stackng-cookies"));

			if (stackCookies && stackCookies.accepted) {
				this.showCookieNotice = false;
			} else {
				this.showCookieNotice = true;
			}
		}
	},
	methods: {
		close() {
			this.showCookieNotice = false;

			if (window.localStorage) {
				const stackCookies = {
					accepted: true,
					dateAccepted: Date.now()
				};
				localStorage.setItem("stackng-cookies", JSON.stringify(stackCookies));
			}
		}
	}
};
</script>

<style scoped>
.cookie-container {
	position: sticky;
	background-color: #51c715;
	bottom: 20px;
	width: 200px;
	margin-left: auto;
	margin-right: 20px;
	margin-bottom: 20px;
	padding: 10px 15px;
	color: #fff;
	border-radius: 10px;
	z-index: 999999;
	box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
		rgba(15, 15, 15, 0.1) 0px 5px 10px, rgba(15, 15, 15, 0.2) 0px 15px 40px;
}

.cookie-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}

.cookie-title span {
	padding: 3px 15px;
	background-color: #000;
	border-radius: 15px;
	font-size: 13px;
	font-weight: bold;
}

.cookie-body p {
	/* color: #b7b7b7; */
	font-size: 13px;
}

.close {
	cursor: pointer;
}

ion-icon[name="ios-megaphone"] {
	color: #fff;
	/* font-size: 23px; */
}

ion-icon[name="ios-close"] {
	color: #000;
	font-size: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/misc/Cookies.vue